// 导入组件，组件必须声明 name
// @ts-ignore
import ExampleTool from './src/example-tool.vue';

// 为组件提供 install 安装方法，供按需引入
(ExampleTool as any).install = (Vue: any) => {
  Vue.component(ExampleTool.name, ExampleTool);
};

// 默认导出组件
export default ExampleTool;
